import { c as _c } from "react/compiler-runtime";
import React, { ReactElement, useRef, useState } from "react";
import style from "./Lists.module.scss";
import { ChevronDown, Info, MoreHorizontal } from "react-feather";
import AnimateHeight from "react-animate-height";
import { GenericListContextMenu, GenericListContextMenuOptions, GenericListContextMenuSelect } from "./GenericListContextMenu";
import { useClickOutsideAlerter } from "../../../../hooks/useClickOutsideAlerter";
import { useInView } from "react-hook-inview";
import { Lightbox } from "../../../shared/components/Lightbox/Lightbox";
export type ListRowCell = {
  value: string;
  tooltip?: string;
  align?: "left" | "right";
};
export type ListRow<T> = {
  id: string;
  defaultExpanded: boolean;
  cells: ListRowCell[];
  details?: ReactElement;
  contextOptions?: GenericListContextMenuOptions;
  onContextSelect?: GenericListContextMenuSelect<T>;
  element: T;
};
type Props<T> = {
  row: ListRow<T>;
  expandable?: boolean;
};
const GenericListRow = t0 => {
  const $ = _c(53);
  const {
    row,
    expandable
  } = t0;
  const [expanded, setExpanded] = useState(row.defaultExpanded);
  const [contextOpen, setContextOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [openTooltips, setOpenTooltips] = useState(t1);
  const [ref, isInView] = useInView();
  const actionRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setContextOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useClickOutsideAlerter(actionRef, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setExpanded(_temp);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const toggleExpanded = t3;
  let actions;
  if ($[3] !== contextOpen || $[4] !== expandable || $[5] !== expanded || $[6] !== row) {
    actions = [];
    if (typeof row.contextOptions !== "undefined") {
      let t4;
      if ($[8] !== contextOpen) {
        t4 = e => {
          e.preventDefault();
          e.stopPropagation();
          setContextOpen(!contextOpen);
        };
        $[8] = contextOpen;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      const t5 = row.id + "-context";
      let t6;
      let t7;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
          display: "flex",
          flexDirection: "column"
        };
        t7 = <MoreHorizontal width={24} />;
        $[10] = t6;
        $[11] = t7;
      } else {
        t6 = $[10];
        t7 = $[11];
      }
      let t8;
      if ($[12] !== contextOpen || $[13] !== row) {
        t8 = contextOpen && <GenericListContextMenu options={row.contextOptions} element={row.element} onSelect={selected => row.onContextSelect ? row.onContextSelect(selected, row.element) : _temp2} />;
        $[12] = contextOpen;
        $[13] = row;
        $[14] = t8;
      } else {
        t8 = $[14];
      }
      let t9;
      if ($[15] !== t8) {
        t9 = <div ref={actionRef} style={t6}>{t7}<div className={style.contextDropdownWrapper}>{t8}</div></div>;
        $[15] = t8;
        $[16] = t9;
      } else {
        t9 = $[16];
      }
      let t10;
      if ($[17] !== t4 || $[18] !== t5 || $[19] !== t9) {
        t10 = <div onClick={t4} data-cy="generic-list-row-context" className={style.actionContainer} key={t5}>{t9}</div>;
        $[17] = t4;
        $[18] = t5;
        $[19] = t9;
        $[20] = t10;
      } else {
        t10 = $[20];
      }
      actions.push(t10);
    }
    if (expandable) {
      let t4;
      if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = e_0 => {
          e_0.stopPropagation();
          toggleExpanded();
        };
        $[21] = t4;
      } else {
        t4 = $[21];
      }
      const t5 = row.id + "-expand";
      const t6 = expanded ? style.iconChevronUp : style.iconChevronDown;
      let t7;
      if ($[22] !== t6) {
        t7 = <ChevronDown className={t6} color="black" width="24px" />;
        $[22] = t6;
        $[23] = t7;
      } else {
        t7 = $[23];
      }
      let t8;
      if ($[24] !== t5 || $[25] !== t7) {
        t8 = <div onClick={t4} data-cy="generic-list-row-expand" className={style.actionContainer} key={t5}>{t7}</div>;
        $[24] = t5;
        $[25] = t7;
        $[26] = t8;
      } else {
        t8 = $[26];
      }
      actions.push(t8);
    }
    $[3] = contextOpen;
    $[4] = expandable;
    $[5] = expanded;
    $[6] = row;
    $[7] = actions;
  } else {
    actions = $[7];
  }
  const t4 = row.id;
  let t5;
  if ($[27] !== expandable) {
    t5 = () => expandable && toggleExpanded();
    $[27] = expandable;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  const t6 = expandable ? style.expandableRow : "";
  let t7;
  if ($[29] !== openTooltips || $[30] !== row.cells) {
    let t8;
    if ($[32] !== openTooltips) {
      t8 = (cell, i) => <td key={i} className={cell.align ? cell.align === "right" ? style.rightAlignCell : "" : ""}><div className={style.cellContent}>{cell.value}{cell.tooltip ? <><Info size="1rem" className={style.extraInfoIcon} onClick={e_1 => {
              e_1.stopPropagation();
              const newSet = new Set(openTooltips);
              newSet.add(i);
              setOpenTooltips(newSet);
            }} data-cy="tooltip-icon" /><Lightbox open={openTooltips.has(i)} onConfirm={() => {
              const newSet_0 = new Set(openTooltips);
              newSet_0.delete(i);
              setOpenTooltips(newSet_0);
            }}><div className={style.cellTooltipContent}><span>{cell.tooltip}</span></div></Lightbox></> : null}</div></td>;
      $[32] = openTooltips;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    t7 = row.cells.map(t8);
    $[29] = openTooltips;
    $[30] = row.cells;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[34] !== actions) {
    t8 = <td className={style.rowAction}><div className={style.cellContent}>{actions.map(_temp3)}</div></td>;
    $[34] = actions;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== row.id || $[37] !== t5 || $[38] !== t6 || $[39] !== t7 || $[40] !== t8) {
    t9 = <tr key={t4} onClick={t5} data-cy="generic-list-row-expand" className={t6}>{t7}{t8}</tr>;
    $[36] = row.id;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== expandable || $[43] !== expanded || $[44] !== isInView || $[45] !== row.cells.length || $[46] !== row.details || $[47] !== row.id) {
    t10 = expandable ? <tr key={`${row.id}-expanded`}><td colSpan={row.cells.length + 1} className={style.detailRowCell}><AnimateHeight height={expanded ? "auto" : 0} animateOpacity={true}>{(expanded || isInView) && row.details}</AnimateHeight></td></tr> : null;
    $[42] = expandable;
    $[43] = expanded;
    $[44] = isInView;
    $[45] = row.cells.length;
    $[46] = row.details;
    $[47] = row.id;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  let t11;
  if ($[49] !== ref || $[50] !== t10 || $[51] !== t9) {
    t11 = <tbody ref={ref}>{t9}{t10}</tbody>;
    $[49] = ref;
    $[50] = t10;
    $[51] = t9;
    $[52] = t11;
  } else {
    t11 = $[52];
  }
  return t11;
};
export default GenericListRow;
function _temp(expanded_0) {
  return !expanded_0;
}
function _temp2() {}
function _temp3(action, i_0) {
  return action;
}